
<h1 class="report-title">Report : LOS Data Source Report</h1>
@if (!currReport) {
<div>
  @if(pageLoading){
  <div>
    <app-lt-spinner></app-lt-spinner>
  </div>
  }
</div>
} @else {

  @if (currReport.hasFilterCards) {
    <div class="report-filter-cards">
      <app-dashboard-cards>
        <app-dashboard-filter-card title="DataSource Type">
          <ng-template>
            <app-lt-multiselect-t
              [data]="dataSourceTypeItems"
              panelWidth=""
              label="DataSource Type"
              textField="description"
              valueField="dataSourceTypeId"
              placeholder="Select Data Source Type..."
            [(ngModel)]="dataSourceItemsSelected"></app-lt-multiselect-t>
          </ng-template>
        </app-dashboard-filter-card>
        <app-dashboard-filter-card title="Destination Endpoints">
          <ng-template>
            <app-lt-multiselect-t
              [data]="destinationEndpointItems"
              panelWidth=""
              textField="displayName"
              valueField="destinationEndpointId"
              placeholder="Select Destination Endpoints..."
            [(ngModel)]="destinationEndpointItemsSelected"></app-lt-multiselect-t>
          </ng-template>
        </app-dashboard-filter-card>
      </app-dashboard-cards>
    </div>
    <div class="report-command-button-group">
      <button type="button" class="btn btn-outline-secondary" (click)="resetFilters()">
        Reset Filters
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="applyFilters()" >
        Apply Filters
      </button>
    </div>
  }
  <div class="report-grid-wrapper">
    <app-lt-png-table #integrationInformationGrid [gridSettingsInput]="integrationInformationGridSettings()"></app-lt-png-table>
  </div>

}

